// inv/src/components/ui/button.jsx
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  // base
  "inline-flex w-auto max-w-full items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 " +
    "[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_img]:size-4 [&_img]:shrink-0 [&_img]:object-contain",
  {
    variants: {
      variant: {
        default: "bg-stone-900 text-white shadow hover:bg-stone-900/90 cursor-pointer",
        destructive: "bg-stone-900 text-destructive-foreground shadow-sm hover:bg-stone-900/90",
        outline:
          "text-stone-900 border border-input cursor-pointer",
        secondary:
          "bg-emerald-300 text-secondary-foreground shadow-sm hover:bg-emerald-500 cursor-pointer ",
        ghost: "hover:bg-accent hover:text-accent-foreground cursor-pointer",
        link: "text-stone-900 underline-offset-4 hover:underline cursor-pointer",
      },
      size: {
        default: "h-9 px-4 py-2",
        xs: "h-6.5 rounded-md px-3 text-xs",
        sm: "h-7.5 rounded-md px-3 text-xs",
        lg: "h-10 w-full sm:w-[80%] rounded-md px-4 sm:px-8",
        icon: "h-9 w-9",
      },
      wrap: {
        nowrap: "whitespace-nowrap",
        wrap: "whitespace-normal break-words",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      wrap: "nowrap",
    },
  }
);

const Button = React.forwardRef(
  (
    {
      className,
      variant,
      size,
      wrap,
      iconLeft,
      iconRight,
      href,
      asChild,
      children,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : href ? "a" : "button";

    return (
      <Comp
        ref={ref}
        href={href}
        className={cn(buttonVariants({ variant, size, wrap, className }))}
        {...props}
      >
        {iconLeft && <span className="flex items-center">{iconLeft}</span>}
        <span className="inline-flex items-center">{children}</span>
        {iconRight && <span className="flex items-center">{iconRight}</span>}
      </Comp>
    );
  }
);

Button.displayName = "Button";

export { Button, buttonVariants };
